import angular from 'angular';
import onboardingContent from './onboardingContent';
import './style.scss';

export default angular
  .module('components.onboardingContent', [])
  .component('onboardingContent', onboardingContent).name;
